import React, { useState } from 'react';
import { FireIcon } from '@icons/FireIcon';
import { translate } from '@utils/i18n';
import NewItemSection from './components/NewItemSection';
import first from './animations/first.json';
import second from './animations/second.json';
import third from './animations/third.json';
import fourth from './animations/fourth.json';
import './WhatsNewModalStyles.scss';
const namespace = 'whats_new_modal';
const TABS = [
    {
        id: 'inspection_assistant',
        tabLabel: translate('feature_1', { namespace }),
        title: translate('feature_1_title', { namespace }),
        description: translate('feature_1_description', { namespace }),
        animationData: first,
        animationHeight: 297
    },
    {
        id: 'proposal_assistant',
        tabLabel: translate('feature_2', { namespace }),
        title: translate('feature_2_title', { namespace }),
        description: translate('feature_2_description', { namespace }),
        animationData: second,
        animationHeight: 270
    },
    {
        id: 'fire_code_expert',
        tabLabel: translate('feature_3', { namespace }),
        title: translate('feature_3_title', { namespace }),
        description: translate('feature_3_description', { namespace }),
        animationData: third,
        animationHeight: 297
    },
    {
        id: 'sales_assistant',
        tabLabel: translate('feature_4', { namespace }),
        title: translate('feature_4_title', { namespace }),
        description: translate('feature_4_description', { namespace }),
        animationData: fourth,
        animationHeight: 270
    }
];
export default function WhatsNewContent({ useTalkToSalesFeature = true }) {
    const [activeTab, setActiveTab] = useState(TABS[0].id);
    const handleTalkToSales = () => {
        window.open('https://www.inspectpoint.com/inspection-assistant-customer-product', '_blank', 'noopener,noreferrer');
    };
    const activeTabContent = TABS.find((tab) => tab.id === activeTab) || TABS[0];
    return (React.createElement("div", { className: "whats-new-modal__content" },
        React.createElement("div", { className: "whats-new-modal__layout" },
            React.createElement("div", { className: "whats-new-modal__sidebar" },
                React.createElement(FireIcon, { width: 38, height: 48 }),
                React.createElement("h3", { className: "whats-new-modal__sidebar-title" }, translate('streamline_quality', { namespace })),
                React.createElement("p", { className: "whats-new-modal__sidebar-subtitle" }, translate('intelligently_check', { namespace })),
                React.createElement("ul", { className: "whats-new-modal__tabs" }, TABS.map((tab) => (React.createElement("li", { key: tab.id, className: "whats-new-modal__tab-item" },
                    React.createElement("button", { type: "button", className: `whats-new-modal__tab ${activeTab === tab.id ? 'whats-new-modal__tab--active' : ''}`, onClick: () => setActiveTab(tab.id) },
                        React.createElement("span", { className: "whats-new-modal__tab-text" }, tab.tabLabel))))))),
            React.createElement("div", { className: "whats-new-modal__main" },
                useTalkToSalesFeature && (React.createElement(NewItemSection, { title: activeTabContent.title, description: activeTabContent.description, animationData: activeTabContent.animationData, animationHeight: activeTabContent.animationHeight, onTalkToSales: handleTalkToSales })),
                !useTalkToSalesFeature && (React.createElement(NewItemSection, { title: activeTabContent.title, description: activeTabContent.description, animationData: activeTabContent.animationData, animationHeight: activeTabContent.animationHeight }))))));
}
